import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=fd4a28de&scoped=true&"
import script from "./IconArrow.vue?vue&type=script&lang=js&"
export * from "./IconArrow.vue?vue&type=script&lang=js&"
import style0 from "./IconArrow.vue?vue&type=style&index=0&id=fd4a28de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4a28de",
  null
  
)

export default component.exports